import { PATH } from 'data';
import { CategoryHierarchyType, CategoryType } from 'types';

export const __GenerateCategoryHierarchy = (
    category?: CategoryType<'list'>,
    categories?: CategoryHierarchyType[],
): { title: string; href?: string }[] => {
    if (categories && category) {
        // search in level 1
        const parent = categories.find((i) => i.id === category.id);
        if (parent) return [{ title: parent.title, href: PATH.posts({ category: parent }) }];

        // search in nested levels
        for (let index = 0; index < categories.length; index++) {
            const cat = categories[index];
            if (cat.children) {
                const child = cat.children.find((i) => i.id === category.id);
                if (child)
                    return [
                        { title: cat.title, href: PATH.posts({ category: cat }) },
                        { title: child.title, href: PATH.posts({ category: child }) },
                    ];

                // search in nested levels
                for (let innerIndex = 0; innerIndex < cat.children.length; innerIndex++) {
                    const catChild = cat.children[innerIndex];
                    if (catChild.children) {
                        const grand = catChild.children.find((i) => i.id === category.id);
                        if (grand)
                            return [
                                { title: cat.title, href: PATH.posts({ category: cat }) },
                                { title: catChild.title, href: PATH.posts({ category: catChild }) },
                                { title: grand.title, href: PATH.posts({ category: grand }) },
                            ];
                    }
                }
            }
        }
    } else return [];
    return [{ title: category.title, href: PATH.posts({ category }) }];
};
